import React from 'react';
import { problems } from '../data/content';
export function Problems() {
  return <section className="w-full border-t border-neutral-200 bg-white px-5 py-16 sm:px-8" data-id="element-237" data-mp="36w14pjlu4pfb">
      <div className="mx-auto w-full max-w-4xl" data-id="element-238" data-mp="3251526lbzt94">
        <h2 className="text-center text-3xl font-extrabold leading-tight tracking-tight text-neutral-900 sm:text-4xl" data-id="element-239" data-mp="323q1a6rvyli0">
          If you coach basketball, you are probably dealing with at least one of these
          problems:
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-240" data-mp="2t2038i3i0ob9">
          {problems.map(problem => <li key={problem} className="flex items-start gap-3 rounded-xl border border-neutral-200 bg-neutral-50 px-5 py-4" data-id="element-241" data-mp="2o7mc4rvvd3ce">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-242" data-mp="2f662wngsj79r">
                ❌
              </span>
              <span className="text-[15px] font-semibold text-neutral-900" data-id="element-243" data-mp="hcpmk50uyc3h">
                {problem}
              </span>
            </li>)}
        </ul>

        <p className="mt-12 text-center text-2xl font-extrabold leading-tight tracking-tight text-ember sm:text-3xl" data-id="element-244" data-mp="34ptmy1jc3dvd">
          What if all of this was already done for you?
        </p>
      </div>
    </section>;
}